import { getCookie } from "mmbclient/Common/CommonFunctions";
import { USER_COOKIE_NAME } from "mmbclient/Common/CommonVariable";
import './HomePage.css'



export function HomePage() {

    return (
        <>
            <div className="container-fluid d-flex flex-column min-vh-100">
                <div className="border p-4 flex-grow-1">
                    <h2 className="text-left custom-bg text-white p-2 mb-0">Welcome to</h2>
                    <div className="text-center mt-3">
                        <img
                            src={(getCookie(USER_COOKIE_NAME) === '') ? "" : "/mmbclient/assets/img/" + getCookie(USER_COOKIE_NAME) + ".png"}
                            alt="Logo"
                            className="img-fluid"
                            style={{ display: 'block', margin: '0 auto' }} // Center the image
                        />
                    </div>
                </div>
            </div>
        </>
    )
}